import React from "react";
import moment from "moment";
import {
    Calendar,
    Callout,
    Checkbox,
    DayOfWeek,
    DefaultButton,
    DirectionalHint,
    FocusTrapZone,
    Spinner,
    SpinnerSize,
    Stack,
    Text,
    Toggle,
} from "office-ui-fabric-react";
import { useHistory } from "react-router";
import { getMomStatusCountByCEM } from "../../services/dashboard/DashboardService";
import { IMomStatusGraphCount } from "../../vm";
import { childrenGap, DayPickerStrings } from "../common/Constants";
import { ToastContext } from "../common/ToastProvider";
import { BarExtendedDatum, ResponsiveBar } from "@nivo/bar";

export interface MomStatusGraphProps { }
let calendarButtonElement: HTMLElement;
const wrapperStyles = {
    margin: "0 auto",
};

const MomStatusGraph: React.FC<MomStatusGraphProps> = () => {
    // custom hooks
    const { showToast } = React.useContext(ToastContext);
    const history = useHistory();

    // state
    const [state, setState] = React.useState({
        isLoading: false,
        momStatus: [],
        searchObj: {
            startDate: moment().startOf("month").toDate(),
            endDate: moment().endOf("month").toDate(),
            // startDate: moment().subtract(1, "month").startOf("month").toDate(),
            // endDate: moment().subtract(1, "month").endOf("month").toDate(),
            ignoreDateRange: true,
        },
        date: moment().toDate(),
        // date: moment().subtract(1, "month").toDate(),
        showCallender: false,
        graphToggle: false
    } as {
        isLoading: boolean;
        momStatus: IMomStatusGraphCount[];
        searchObj: {
            startDate: Date | string;
            endDate: Date | string;
            ignoreDateRange: boolean;
        };
        date: Date;
        showCallender: boolean;
        graphToggle: boolean;
    });

    // hooks
    React.useEffect(() => {
        const asyncFunc = async () => {
            await getMomStatus();
        };
        asyncFunc();
    }, []);

    const getMomStatus = async (paramState?: any) => {
        let localState = { ...state };
        if (paramState) {
            localState = { ...localState, ...paramState };
        }
        setState({ ...localState, isLoading: true });
        let searchObj = { ...localState.searchObj };
        searchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
        searchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");

        let result = await getMomStatusCountByCEM(searchObj);
        if (result?.success) {
            setState({
                ...localState,
                momStatus: result.data,
                isLoading: false
            });
        } else {
            setState({ ...localState, isLoading: false });
            showToast(result?.message || "Error while getting mom status", "error");
        }
    };

    const closeCallender = (ev?: any) => {
        setState({
            ...state,
            showCallender: false,
        });
    };

    const viewMomStatusDetails = (item: BarExtendedDatum) => {
        console.log(item);
        history.push(
            `/mom-status-count?startDate=${moment(state.searchObj.startDate).format(
                "YYYY-MM-DD"
            )}&endDate=${moment(state.searchObj.endDate).format(
                "YYYY-MM-DD"
            )}&status=${item.id === 'Work In Progress' ? 'wip' : String(item.id).toLowerCase()}&cemId=${item.data.id}&ignoreDateRange=${state.searchObj.ignoreDateRange
            }`
        );
    };

    return (
        <React.Fragment>
            <div style={wrapperStyles}>
                <div className="ms-Grid p-0">
                    <div className="ms-Grid-row ms-motion-scaleDownIn status-count-card overflow ml-0 mr-0">
                        {state.isLoading && (
                            <div className="custom-card spinner-center">
                                <Spinner size={SpinnerSize.large} />
                            </div>
                        )}
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
                            <Stack horizontal horizontalAlign="space-between">
                                <Stack.Item>
                                    <Text className="dashboard-card-title">MOM</Text>
                                </Stack.Item>
                                <Stack.Item>
                                    <Stack
                                        horizontal
                                        wrap
                                        tokens={childrenGap}
                                        verticalAlign="center"
                                        horizontalAlign="end"
                                    >
                                        <Stack.Item>
                                            <div
                                                ref={(calendarBtn) =>
                                                    (calendarButtonElement = calendarBtn!)
                                                }
                                            >
                                                <DefaultButton
                                                    text={
                                                        !state.date
                                                            ? "Select a month"
                                                            : moment(state.date).format("MMM-YYYY")
                                                    }
                                                    onClick={() =>
                                                        setState({ ...state, showCallender: true })
                                                    }
                                                    className="month-picker-btn"
                                                    disabled={state.searchObj.ignoreDateRange}
                                                />
                                            </div>
                                            {state.showCallender && (
                                                <Callout
                                                    isBeakVisible={false}
                                                    // className="ms-DatePicker-callout"
                                                    gapSpace={0}
                                                    doNotLayer={false}
                                                    target={calendarButtonElement}
                                                    directionalHint={DirectionalHint.bottomLeftEdge}
                                                    onDismiss={() => closeCallender()}
                                                    setInitialFocus
                                                >
                                                    <FocusTrapZone
                                                        firstFocusableSelector="ms-DatePicker-day--today"
                                                        isClickableOutsideFocusTrap
                                                    >
                                                        <Calendar
                                                            // eslint-disable-next-line react/jsx-no-bind
                                                            onSelectDate={async (
                                                                date: Date | null | undefined
                                                            ) => {
                                                                // setState()
                                                                let obj = {
                                                                    ...state,
                                                                    date: date as Date,
                                                                    searchObj: {
                                                                        ...state.searchObj,
                                                                        startDate: moment(date)
                                                                            .startOf("month")
                                                                            .toDate(),
                                                                        endDate: moment(date)
                                                                            .endOf("month")
                                                                            .toDate(),
                                                                    },
                                                                    showCallender: false,
                                                                };
                                                                await getMomStatus(obj);
                                                            }}
                                                            onDismiss={() => closeCallender()}
                                                            isMonthPickerVisible={true}
                                                            value={state.date}
                                                            firstDayOfWeek={DayOfWeek.Sunday}
                                                            strings={DayPickerStrings}
                                                            isDayPickerVisible={false}
                                                            highlightCurrentMonth={false}
                                                            highlightSelectedMonth={true}
                                                            showMonthPickerAsOverlay={false}
                                                            showGoToToday={false}
                                                            maxDate={new Date(Date.now())}
                                                        />
                                                    </FocusTrapZone>
                                                </Callout>
                                            )}
                                        </Stack.Item>
                                        <Stack.Item>
                                            <Checkbox
                                                label="Show All data irrespective of date"
                                                checked={state.searchObj.ignoreDateRange}
                                                onChange={async (e, v) => {
                                                    let obj = {
                                                        ...state,
                                                        searchObj: {
                                                            ...state.searchObj,
                                                            ignoreDateRange: v,
                                                        },
                                                    };
                                                    await getMomStatus(obj as any);
                                                }}
                                            />
                                        </Stack.Item>
                                        <Stack.Item>
                                            <Toggle
                                                className="pointer"
                                                onText="Grouped Chart"
                                                offText="Grouped Chart"
                                                onChange={(e, v) => {
                                                    setState({
                                                        ...state,
                                                        graphToggle: v as boolean,
                                                    });
                                                }}
                                            />
                                        </Stack.Item>
                                    </Stack>
                                </Stack.Item>
                            </Stack>
                            <hr />
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col pt-0 ms-sm12 ms-md12 ms-lg12">
                                    <div
                                        className={`bar-container ${state.momStatus.length === 0 ? "no-data" : ""
                                            }`}
                                    >
                                        {state.momStatus.length > 0 ? (
                                            <ResponsiveBar
                                                data={state.momStatus.map((d) => {
                                                    return {
                                                        id: d._id,
                                                        label: d.userName,
                                                        Open: d.open,
                                                        OpenColor: "#daa520",
                                                        // Pending: d.pending,
                                                        // PendingColor: "#daa520",
                                                        "Work In Progress": d.wip,
                                                        "Work In ProgressColor": "#008000",
                                                        Closed: d.closed,
                                                        ClosedColor: "#d62828",
                                                        "Under Observation": d["under-observation"],
                                                        "Under ObservationColor": "#135c8a",
                                                    };
                                                })}
                                                keys={[
                                                    "Open",
                                                    // "Pending",
                                                    "Under Observation",
                                                    "Work In Progress",
                                                    "Closed",
                                                ]}
                                                onClick={(data) =>
                                                    viewMomStatusDetails(data)
                                                }
                                                groupMode={state.graphToggle ? "grouped" : "stacked"}
                                                indexBy="label"
                                                margin={{ top: 50, right: 30, bottom: 50, left: 50 }}
                                                padding={state.graphToggle === true ? 0.1 : 0.3}
                                                colors={({ id, data }) => data[`${id}Color`]}
                                                borderColor={{
                                                    from: "color",
                                                    modifiers: [["darker", 1.6]],
                                                }}
                                                axisTop={null}
                                                axisRight={null}
                                                axisBottom={{
                                                    tickSize: 10,
                                                    tickPadding: 10,
                                                    tickRotation: 0,
                                                }}
                                                axisLeft={{
                                                    tickSize: 10,
                                                    tickPadding: 15,
                                                    tickRotation: 0,
                                                    format: (v) => `${v}`,
                                                }}
                                                labelSkipWidth={12}
                                                labelSkipHeight={12}
                                                labelTextColor="#fff"
                                                legends={[
                                                    {
                                                        dataFrom: "keys",
                                                        anchor: "top",
                                                        direction: "row",
                                                        justify: false,
                                                        translateX: 20,
                                                        translateY: -50,
                                                        itemsSpacing: 30,
                                                        itemWidth: 100,
                                                        itemHeight: 20,
                                                        itemDirection: "left-to-right",
                                                        itemOpacity: 0.85,
                                                        symbolSize: 20,
                                                        effects: [
                                                            {
                                                                on: "hover",
                                                                style: {
                                                                    itemOpacity: 1,
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ]}
                                                animate={true}
                                                motionStiffness={90}
                                                motionDamping={15}
                                            />
                                        ) : (
                                            <>
                                                <br />
                                                <Text>No Customer Meetings Found</Text>
                                                <br />
                                                <br />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MomStatusGraph;
